import * as actionTypes from './actionTypes'
import { Map } from 'immutable'

export const setTargetParamValue =
  (uid, value, path = []) =>
  (dispatch) => {
    dispatch({
      type: actionTypes.SET_STORE_PARAM,
      payload: {
        uid,
        value,
        path,
      },
    })
  }

export const setTargetParamsValue =
  (data, isLoginSmartV = true) =>
  (dispatch) => {
    dispatch({
      type: actionTypes.SET_STORE_PARAMS,
      payload: {
        ...data,
        isLoginSmartV,
      },
    })
  }

export const setClearSmartVParams = () => (dispatch, getState) => {
  let state = getState()
  state.getIn(['project', 'Settings', 'SmartV', 'params'], Map()).map((v, k) => {
    state = state.deleteIn(['params', k])
  })
  dispatch({
    type: actionTypes.SET_STORE,
    payload: {
      store: state,
    },
  })
}
